import React, { Component } from 'react';
import Hero from 'components/PageHero/Hero';
import { lazyload } from 'react-lazyload';
import Lightbox from 'react-image-lightbox';

lazyload({
	height: 200,
	once: true,
	offset: 100
});
export default class InformationItem extends Component {
	constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
	render() {
		const { isOpen } = this.state;
		const videoLink = this.props.videoLink;
		const pictureURL = this.props.pictureURL;
		const channel = this.props.channel;
		const textLink = this.props.textLink;
		return (
			<div className="informationGrid">
				{videoLink ? (
					<div className={this.props.informationMedia}>
						<Hero
							imageSrc={pictureURL}
							videoId={videoLink}
							channel={channel}
							showSubtitle
						/>
					</div>
				) :
				(
					<div className={this.props.informationMedia} onClick={() => this.setState({ isOpen: true })}>
						<Hero
							imageSrc={pictureURL}
							videoId={videoLink}
							channel={channel}
							showSubtitle
						/>

						{isOpen && (
				          <Lightbox
				            mainSrc={this.props.pictureURL}
				            onCloseRequest={() => this.setState({ isOpen: false })}
				          />
				        )}
					</div>
				)}
					<div className={this.props.informationContent}>
						<h3 className={this.props.h3className}>{this.props.Title}</h3>
						{textLink ? (
							<p className={this.props.pClassName}>
								{this.props.children}
								<a className="link--green" href="https://www.rtl.nl/video/975a10cd-c5ef-4543-9293-a9affc63251d/" target="_blank" rel="noopener">{textLink}</a>
							</p>

						):(
							<p className={this.props.pClassName}>
								{this.props.children}
							</p>
						)}
						
					</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/InformationItem/Information-Item.jsx